export const loginUser = async (email, password) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/login/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      throw new Error("Login failed");
    }

    const data = await response.json();
    return data; // same structure as signup
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};
